// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel-module--label--3ck-1","labelText":"InputLabel-module--labelText--13S1h"};